export class Microsoft365UserChatsSelectedItemsOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<SaasRestoreItem>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365UserChatsSelectedItemsOptions.attributeTypeMap;
    }
    constructor() {
    }
}
